import { useEffect } from 'react';
import useModalState from '../context/modal/useModalState';

const DemoDisclaimerLauncher: React.FC = () => {
    const { openModal } = useModalState();

    useEffect(() => {
        openModal('demoDisclaimerModal');
    }, [openModal]);

    return null;
};

export default DemoDisclaimerLauncher;
